export const WHO_IN_HEALTH_COMMUNITY_SECTION = '63a45f15d7ae57c097eadac3'
export const HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION = '63a45f08d7ae57c097eadac2'
export const FORUM_HEALTH_COMMUNITY_SECTION = '63a45dfdd7ae57c097eadac1'

export const WHO_IN_SECTION_NAME = 'quienseapunta'
export const HEALTHY_INFORMATION_SECTION_NAME = 'informacionsaludable'
export const PATIENTS_LIKE_YOU_IN_SECTION_NAME = 'pacientescomotu'


// WEBPACK FOOTER //
// ./src/constants/healthyCommunitySections.js